module.exports = __webpack_public_path__ + "static/img/tabela.8b59244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-sgas/tabela.png
// module id = tYmI
// module chunks = 0